module.exports = {
      id: "comm-children-usage",
      viewBox: "0 0 237.872 42.449",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#comm-children",
      toString: function () {
        return this.url;
      }
    }